export const ORGANIZATION = {
  firstName: {
    label: 'Owner first name',
    placeholder: 'First name',
    required: true,
    id: 'firstName',
  },
  lastName: {
    label: 'Owner last name',
    placeholder: 'Last name',
    required: true,
    id: 'lastName',
  },
  email: {
    label: 'Owner email',
    placeholder: 'person@somecompany.com',
    required: true,
    id: 'email',
  },
  organizationName: {
    label: 'Organization name',
    placeholder: 'Some company',
    required: true,
    id: 'organizationName',
  },
  website: {
    label: 'Website',
    placeholder: 'www.somecompany.com',
    required: true,
    id: 'website',
  },
  industry: {
    label: 'Industry',
    placeholder: 'E-commerce',
    required: true,
    id: 'industry',
  },
  estimatedSize: {
    helpText: 'Minimum value: 1',
    label: 'Estimated size',
    placeholder: '12000',
    required: true,
    id: 'estimatedSize',
  },
  salesforceAccountId: {
    helpText: 'Must include if the organization is in Salesforce.com',
    label: 'Salesforce Account ID',
    placeholder: '0011a00000lnN9m',
    required: false,
    id: 'slaeforceAccountId',
  },
  trialEnd: {
    label: 'Trial period end date',
    placeholder: 'mm/dd/yyyy',
    required: false,
    id: 'trialEnd',
  },
  bootstrapAccount: {
    label: 'Bootstrap account with Templates/Campaigns',
    required: false,
    id: 'bootstrapAccount',
  },
  shardCount: {
    label: 'Estimated combined count of Users and Events for the first project',
    helpText:
      'Determines Elasticsearch shard count for the first project. Choosing the right size is important to help a project scale without impacting other customers.',
    required: true,
    placeholder: 'Select an option',
    id: 'shardCount',
  },
};

export const SHARD_COUNT_OPTIONS = [
  {
    id: '5',
    label: 'Less than 125M',
    value: '5',
  },
  {
    id: '20',
    label: '125M to 500M',
    value: '20',
  },
  {
    id: '50',
    label: '500M to 1.25B',
    value: '50',
  },
  {
    id: '100',
    label: '1.25B to 2.5B',
    value: '100',
  },
  {
    id: '200',
    label: '2.5B to 5B',
    value: '200',
  },
  {
    id: '400',
    label: 'More than 5B',
    value: '400',
  },
];

/**
 * New Organization form field names. These map directly to the keys expected
 * in the CreateNewOrganizationRequest defined in AccountController.scala.
 */

/**
 * Organization Fields
 */
export const ORGANIZATION_NAME = 'organizationName';
export const WEBSITE = 'website';
export const SALESFORCE_ACCOUNT_ID = 'salesforceAccountId';
export const TRIAL_END_DATE = 'trialEndDate';
export const DATA_POLICY = 'dataPolicy';

/**
 * Administrator Fields
 */
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const EMAIL = 'email';

/**
 * Project Fields
 */
export const PROJECT_NAME = 'projectName';
export const PROJECT_TIME_ZONE = 'projectTimeZone';
export const UNIQUE_IDENTIFIER = 'uniqueIdentifier';
export const SHARD_COUNT = 'shardCount';
export const BOOTSTRAP_ACCOUNT = 'bootstrapAccount';

/** Unique identifier above is a frontend-only field that maps to the
 * isUuidBased and uuidProjectType fields on the backend.
 */
export const IS_UUID_BASED = 'isUuidBased';
export const UUID_PROJECT_TYPE = 'uuidProjectType';
